import React, { createContext, useContext, useState } from 'react'
import PropTypes from 'prop-types'

const OffersContext = createContext(null)

export const useOffers = () => {
  const value = useContext(OffersContext)

  if (value === null) {
    throw new Error(
      'You must wrappe the context with <CareerContextProvider />'
    )
  }
  return value
}

export const CareerContextProvider = ({ children, ...values }) => {
  const [tab, setTab] = useState('content')

  return (
    <OffersContext.Provider
      value={{
        tab,
        setTab,
        ...values,
      }}
    >
      {children}
    </OffersContext.Provider>
  )
}

CareerContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
}

export default OffersContext
